import { useEffect, useMemo } from 'react';
import { RootState } from '@/slices/store';
import { fetchShortlistsThunk, loadShortlistsFromStorage } from '@/slices/features/shortlistsSlice';
import { useAppDispatch, useAppSelector } from '@/slices/hooks';
import { useAuthenticated } from '@/hooks/useAuthenticated';
import { useAccount } from '@/hooks/useAccount';

const useShortlists = () => {
  const { organization } = useAccount();
  const { isAuthenticated } = useAuthenticated();
  const dispatch = useAppDispatch();
  const shortlists = useAppSelector((state: RootState) => state.shortlists.shortlists);
  const loading = useAppSelector((state: RootState) => state.shortlists.loading);
  const error = useAppSelector((state: RootState) => state.shortlists.error);

  useEffect(() => {
    if (!isAuthenticated || !organization || loading) return;

    if (!shortlists) {
      const storedShortlists = localStorage.getItem('shortlists');
      if (storedShortlists) {
        dispatch(loadShortlistsFromStorage());
      } else {
        dispatch(fetchShortlistsThunk(organization.id));
      }
    }
  }, [isAuthenticated, dispatch, shortlists, organization, loading]);

  const standardList = useMemo(() => shortlists?.find((shortlist) => shortlist.standard), [shortlists]);

  return { shortlists, standardList, loading, error };
};

export default useShortlists;
